module.exports = __webpack_public_path__ + "static/media/soviet_cavalry_120x120.90b27649.png";